import Container from "@/components/Container/Container"
import Row from "@/components/Row/Row"
import Col from "@/components/Col/Col"
import styles from "./AboutPlatform.module.scss"
import { Link } from "@/i18n/routing"
import { useTranslations } from "next-intl"

export default function AboutPlatform() {
  const t = useTranslations()

  return (
    <section className={styles.platform}>
      <Container>
        <Row>
          <Col cols="12" sm="24" lg="12" className={styles.platform__important}>
            <strong
              dangerouslySetInnerHTML={{
                __html: t.raw("aboutPlatform.important"),
              }}
            ></strong>
          </Col>

          <Col cols="12" sm="24" lg="12" className={styles.platform__text}>
            <div
              className={styles.platform__desc}
              dangerouslySetInnerHTML={{
                __html: t.raw("aboutPlatform.desc"),
              }}
            ></div>

            <ul className={styles.platform__links}>
              <li>
                <Link href="/events" target="_blank">
                  {t("aboutPlatform.viewEventsLink")}
                </Link>
              </li>
              <li>
                <Link href="/posts" target="_blank">
                  {" "}
                  {t("aboutPlatform.exploreInsightsLink")}
                </Link>
              </li>
            </ul>
          </Col>
        </Row>
      </Container>
    </section>
  )
}
